'use client';

import * as React from 'react';

/** The words this package's own components show; English unless the app provides its own. */
export const defaultUiMessages = {
  themeLight: 'Light',
  themeDark: 'Dark',
  themeSystem: 'System',
  timeAgoWhen: 'When',
  timeAgoLocal: 'Local',
  timeAgoUtc: 'UTC',
};

export type UiMessages = typeof defaultUiMessages;

const UiMessagesContext = React.createContext<UiMessages>(defaultUiMessages);

/** Gives the components below it the app's translations of their text. */
export function UiMessagesProvider({ messages, children }: { messages: UiMessages; children: React.ReactNode }) {
  return <UiMessagesContext value={messages}>{children}</UiMessagesContext>;
}

export function useUiMessages() {
  return React.use(UiMessagesContext);
}
